import os from "os";
import path from "path";
import fs from "fs";
import { RepairRule } from "../repairEngine.js";
import { findPackageJson } from "../../utils/files.js";
import { runCommand } from "../../utils/exec.js";

export const lockfileRepairRules: RepairRule[] = [
  {
    id: "pod-lock-mismatch",
    title: "Fix CocoaPods Lock Mismatch",
    description: "Re-runs 'pod install' if the Podfile.lock and Pods/Manifest.lock files are out of sync.",
    safe: false,
    async detect(cwd: string): Promise<boolean> {
      if (os.platform() !== "darwin") return false;
      const pPath = findPackageJson(cwd);
      if (!pPath) return false;
      const root = path.dirname(pPath);
      const iosPath = path.join(root, "ios");
      const lockfile = path.join(iosPath, "Podfile.lock");
      const manifest = path.join(iosPath, "Pods", "Manifest.lock");

      if (fs.existsSync(lockfile) && fs.existsSync(manifest)) {
        try {
          const lockContent = fs.readFileSync(lockfile, "utf-8").trim();
          const manifestContent = fs.readFileSync(manifest, "utf-8").trim();
          return lockContent !== manifestContent;
        } catch {
          return true;
        }
      }
      return false;
    },
    async repair(cwd: string): Promise<{ success: boolean; details?: string }> {
      const pPath = findPackageJson(cwd);
      if (!pPath) return { success: false, details: "package.json not found." };
      const root = path.dirname(pPath);
      const iosPath = path.join(root, "ios");

      const podCheck = await runCommand("pod --version");
      if (podCheck.error) {
        return { success: false, details: "CocoaPods 'pod' command not found." };
      }

      const result = await runCommand(`cd "${iosPath}" && pod install`);
      if (result.error) {
        return {
          success: false,
          details: `CocoaPods lockfile sync failed: ${result.stderr || result.stdout}`,
        };
      }
      return { success: true, details: "CocoaPods synchronized successfully." };
    },
  },
];
